const translations = {
  title: 'Estoque',
  'menu.transferItems': 'Transferir itens',
  'table.name': 'Nome',
  'table.availableAmount': 'Quantidade disponível',
  'table.totalAmount': 'Quantidade geral',
  'table.active': 'Ativo',
  'table.status.critical': 'Crítico',
  'table.status.warning': 'Alerta',
  'table.status.normal': 'Normal',
  'table.status.noValues': 'Sem valores de volume crítico ou alerta cadastrados',
  'actions.viewDetails': 'Ver detalhes',
  'actions.edit': 'Editar',
  'actions.transfers': 'Movimentações',
  'actions.qrCode': 'QR Code',
  'actions.remove': 'Remover',
  'tabs.details': 'Detalhes',
  'tabs.transfersHistory': 'Histórico de movimentações',
  'tabs.userStocks': 'Estoque por usuário',
  'tabs.placeStocks': 'Estoque por local',
  'tabs.qrCodes': 'QR Codes',
  'transfersHistory.title': 'Histórico de movimentações',
  'transfersHistory.table.date': 'Data',
  'transfersHistory.table.doneBy': 'Feito por',
  'transfersHistory.table.operationType': 'Tipo operação',
  'transfersHistory.table.amount': 'Quantidade',
  item: 'Item',
  'transfersHistory.table.origin': 'Origem',
  'transfersHistory.table.destination': 'Destino',
  'transfersHistory.operation.addToGeneral': 'Adicionar ao estoque geral',
  'transfersHistory.operation.removeGeneralStock': 'Remover do estoque geral',
  'transfersHistory.operation.setGeneralStock': 'Ajustar valor total do estoque geral',
  'transfersHistory.operation.transferFromGeneralToUser': 'Transferir do estoque geral para o usuário',
  'transfersHistory.operation.transferFromUserToGeneral': 'Transferir do usuário para o estoque geral',
  'transfersHistory.operation.transferFromGeneralToPlace': 'Transferir do estoque geral para um local',
  'transfersHistory.operation.transferFromPlaceToGeneral': 'Transferir do local para o estoque geral',
  'transfersHistory.operation.selfUse': 'Uso do usuário',
  'transfersHistory.generalStock': 'Estoque geral',
  'userStocks.title': 'Histórico de transferências',
  'userStocks.table.user': 'Usuário',
  'userStocks.table.amount': 'Quantidade',
  'placeStocks.title': 'Histórico de transferências',
  'placeStocks.table.place': 'Local',
  'placeStocks.table.amount': 'Quantidade',
  'details.availableAmount': 'Quantidade disponível',
  'details.totalAmount': 'Quantidade geral',
  'details.status': 'Status',
  'details.status.active': 'Ativo',
  'details.status.inactive': 'Inativo',
  'qrcodes.noQrCode': 'Nenhum QR Code encontrado',
  'operationType.addToGeneral': 'Adicionar ao estoque geral',
  'operationType.removeGeneralStock': 'Remover do estoque geral',
  'operationType.setGeneralStock': 'Ajustar valor total do estoque geral',
  'operationType.transferFromGeneralToUser': 'Transferir do estoque geral para o usuário',
  'operationType.transferFromUserToGeneral': 'Transferir do usuário para o estoque geral',
  'operationType.transferFromGeneralToPlace': 'Transferir do estoque geral para o local',
  'operationType.transferFromPlaceToGeneral': 'Transferir do local para o estoque geral',
  'operationType.selfUse': 'Consumo próprio'
}

export default translations
